import { render, staticRenderFns } from "./PlayerProcessedMenu.vue?vue&type=template&id=24f1cd23&scoped=true&"
import script from "./PlayerProcessedMenu.vue?vue&type=script&lang=js&"
export * from "./PlayerProcessedMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProcessedMenu.vue?vue&type=style&index=0&id=24f1cd23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1cd23",
  null
  
)

export default component.exports